var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrev(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.000000 60.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,60.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M203 582 c-251 -90 -272 -432 -35 -549 81 -40 183 -40 264 0 107 53 163 144 163 267 0 85 -21 142 -74 203 -72 81 -213 117 -318 79z m187 -18 c105 -31 190 -149 190 -264 0 -118 -85 -234 -195 -266 -236 -68 -443 171 -335 387 65 129 198 185 340 143z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335 502 c-41 -29 -175 -184 -175 -202 0 -22 147 -186 182 -204 14 -7 25 -3 43 14 14 13 25 30 25 38 0 8 -30 45 -67 83 l-66 69 66 69 c37 38 67 75 67 83 0 16 -41 58 -56 58 -5 0 -14 -4 -19 -8z m40 -32 c18 -20 17 -22 -48 -89 -37 -38 -67 -74 -67 -81 0 -7 30 -43 67 -81 l67 -70 -22 -21 -22 -22 -84 89 c-47 50 -85 96 -86 103 0 13 159 192 171 192 3 0 14 -9 24 -20z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.abcc7f5f14dd5d891146ac3122327a48.svg";
export { ForwardRef as ReactComponent };